module.exports = __webpack_public_path__ + "img/banniere.2d82dff8.jpg";